module.exports = __webpack_public_path__ + "media/flags/jo-edc26c44.svg";